module.exports = __webpack_public_path__ + "img/4-4.bade9fc1.jpg";